import { atom } from 'jotai'
import { ActionSheet } from 'types/types'

export const actionAtom = atom<ActionSheet>({} as ActionSheet)
actionAtom.debugLabel = 'action'
